import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Button, DialogTitle, Stack, TextField } from '@mui/material';

import { patchProjectAtom, selectedProjectIdAtom } from '@/interfaces/project';

interface EditProjectNameProps {
  initialValue: string;
  onClose: (reason?: string) => void;
}

export default function EditProjectName({ initialValue, onClose }: EditProjectNameProps) {
  const projectId = useAtomValue(selectedProjectIdAtom);
  const { mutate, isPending, data: isSuccess } = useAtomValue(patchProjectAtom);

  const [projectName, setProjectName] = useState(initialValue);
  const { t } = useTranslation();

  useEffect(() => {
    if (isSuccess === undefined) return;
    if (isSuccess) {
      onClose('updated');
    } else {
      window.alert(t('Common.message.serverErrorOccurred'));
    }
  }, [isSuccess, onClose, t]);

  function onOkClick() {
    mutate({ projectId, projectName });
  }

  return (
    <Stack gap={2} sx={{ minWidth: 480, p: 3 }}>
      <DialogTitle sx={{ px: 0 }}>{t('Projects.label.projectName')}</DialogTitle>
      <TextField value={projectName} onChange={(e) => setProjectName(e.target.value)} />

      <Stack direction="row" justifyContent="center" gap={3}>
        <Button variant="contained" onClick={() => onClose()} sx={{ bgcolor: '#CCC', color: 'black' }}>
          {t('Common.label.cancel')}
        </Button>
        <Button
          variant="contained"
          disabled={projectName.length === 0 || projectName.length > 45 || isPending}
          onClick={onOkClick}
          sx={{ bgcolor: 'info.main' }}
        >
          {t('Common.label.ok')}
        </Button>
      </Stack>
    </Stack>
  );
}
